import React from "react";
import "../all css/visionsection.css";
const badge_icon = require("../../assets/aboutexplore/badge.png");
const vision_img = require("../../assets/aboutexplore/vison_red_img.png");

function VisionSection(props) {
  return (
    <div className="vision_section_man_container">
      <div className="vision_section_under_main_container">
        <div className="vision_section_header_content">
          <div className="title_of_vision_text_container">
            <p className="title_vision_text wow pulse animated"
             data-wow-delay="500ms"
             data-wow-iteration="infinite"
             data-wow-duration="1s"
            >OUR VISION</p>
            <p className="description_vision_text">
              Your vision will become clear only when you can look into your own
              heart. Who looks outside, dreams; who looks inside, awakes.
            </p>
          </div>

          <div className="vision_box_container wow bounceInRight center">
            <img src={badge_icon} alt="badge" className="bagde_icon_sele" />
            <p>To become the most trusted and preferred partner offering <span className="highlight_about_us_content">overseas  
              education </span>  to global students. </p>
            
          </div>
        </div>
        <div className="body_section_vision_content">
          <div className="img_of_vision_container">
            <img className="vision_img" alt="vision_img" src={vision_img} />
          </div>

          <div className="vision_box_container1 wow bounceInLeft center">
            <img src={badge_icon} alt="badge" className="bagde_icon_sele" />
            <p>
            To enable aspiring students to access the best  
            <span className="highlight_about_us_content"> universities and academic degrees </span> 
             in the subjects of their 
            choice and help them kickstart their overseas education journey.
              </p>
    
            
          </div>
        </div>
      </div>
    </div>
  );
}

export default VisionSection;
